require('./fiocUploadDocumentsView.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ utilities
const { tagFiocDocumentationStart } = require('utilities/taggingInfo/fiocTags');
const { isDocumentUploadAllowed } = require('utilities/contactCenter/printerHelper');
const { contactCenterClassName } = require('utilities/conditionals/conditionalClassname')
// @ actions
const fiocDocumentation = require('actions/fiocDocumentation');
const interstitialsActions = require('actions/interstitialGeneric');
// @ commons
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const ContactInfoBox = require('components/myProfile/contactInfoBox/contactInfoBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
const FiocUploadBoxes = require('components/fioc/fiocUploadBoxes/fiocUploadBoxes.js');
const { OKMessage } = require('commonsComponents/OKMessage');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKModal = require('components/commons/OKModal/OKModal');
const openbankLogo = require('assets/images/Openbank_logo_blanco.svg');

const { FIOC_DOCUMENT_CODE_01, FIOC_DOCUMENT_CODE_03 } = require('constants/index');

const FILE_MAX_SIZE = 12288;
const VALID_TYPES_FILE = ["pdf", "jpg", "jpeg", "bmp", "png", "heic", "heif"];

class FIOCUploadDocumentsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            successUpload: false,
            isError: true,
            showAddressProofModal: false,
            modalContent: "ingresos",
            isAttachClicked: false
        }
        this.mapDocumentStatusToIcon = {
            "RN": "error",
            "RK": "error",
            "RE": "exito",
            "RV": "informacion"
        };

        this.handleUpload = this.handleUpload.bind(this);
        this.modalOpen = this.modalOpen.bind(this);
        this.handleCloseModel = this.handleCloseModel.bind(this);
        this.removeChange = this.removeChange.bind(this);
        this.addChange = this.addChange.bind(this);
        this.checkUploadDisable = this.checkUploadDisable.bind(this);
        this.handleContinueUploadClick = this.handleContinueUploadClick.bind(this);
        this.isDesktop = this.isDesktop.bind(this);     
    }

    componentDidMount() {
        const { getFiocStatus, getFiocContent, fiocFetched } = this.props;
        getFiocContent();
        tagFiocDocumentationStart();
        if (!fiocFetched) {
            getFiocStatus()
        }
    }

    addChange(fileState) {
        this.props.addFile(fileState);
    }

    handleRedirectToCloseMobileFIOC = () => {
        window.location.href = '/myprofile/global/';
    }

    buildDisclaimerPersonalInfo() {
        const link = formatText('disclaimerPersonalInfo-fiocDocumentationLinkUrl');
        return (
            <div className="fioc-upload-documents-view__disclaimer-gdpr">
                <OKMessage type="informative">
                    <FormattedText value="disclaimerPersonalInfo-fiocDocumentationMsg" />
                    &nbsp;
                    <OKLink modifier="emphasize" to={link} target="_blank">
                        <FormattedText value="disclaimerPersonalInfo-fiocDocumentationLinkText" />
                    </OKLink>
                </OKMessage>
            </div>
        );
    }

    isDesktop() {
        this.props.immScreen.get('isDesktop')
    }

    checkUploadDisable() {
        let isDisable = true, doc01Count = 0, doc03Count = 0;
        const { files } = this.props;
        files.map((file) => {
            const documentCode = file["name"].split("-")[1];
            if (documentCode === FIOC_DOCUMENT_CODE_01) {
                doc01Count++;
            } else if (documentCode === FIOC_DOCUMENT_CODE_03) {
                doc03Count++;
            } else {
                isDisable = false;
                return false;
            }
        });
        if (doc01Count === 2 || doc03Count === 3) {
            return false;
        }
        return isDisable;
    }

    createBodyContent() {
        const { documentList,
            files,
            documentListError,
            uploadDocumentsPending,
            uploadFIOCDocumentsSuccess,
            uploadFIOCDocumentsError,
            immScreen
        } = this.props;
        const uploadDocumentSectionSubTitle = (
            <p className="fioc-upload-documents-view__subtitle">
                <FormattedText
                    className="fioc-upload-documents-view__subtitle__bold-subtitle"
                    value="fiocSection-documentUploadSectionSubtitle1"
                />
                {isDocumentUploadAllowed() && <FormattedText value="fiocSection-documentUploadSectionSubtitle2" />}
            </p>
        );
        const uploadInstructions = isDocumentUploadAllowed() ? this.createUploadInstructions() : null;
        const documentListBox = this.createDocumentListBox();
        const uploadInformation = this.createUploadInformation();
        const goBackButton = {
            label: this.props.immScreen.get('isDesktop') ? formatText("fiocSection-documentUploadSuccessSectionLink") : formatText("common-accept"),
            url: this.props.immScreen.get('isDesktop') ? '/myprofile/edit' : null
        };
        const failedDocuments = [];
        let isAnyDocumentFailed = false;
        let documentCode;
        uploadFIOCDocumentsSuccess && uploadFIOCDocumentsSuccess.filter(response => {
            let statusCode = response.getIn(['response', 'expediente', 'estado']);
            if ((response.getIn(['statusCode']) === "KO") || (statusCode === "RK")) {
                documentCode = response.getIn(['response', 'expediente', 'tipo']);
                if (documentCode === "00") {
                    documentCode = response.getIn(['response', 'expediente', 'subtipo']);
                }
                documentCode && failedDocuments.push(formatText("fiocSection-documentName" + documentCode));
                isAnyDocumentFailed = true;
            }
        })
        if (this.state.successUpload) {
            let wizard;
            if (uploadDocumentsPending) {
                wizard = (<LoadingSection />);
            } else if (uploadFIOCDocumentsError) {
                wizard = (
                    <WizardError
                        customClassName={`fioc-upload-documents-view__error-wizard ${!immScreen.get('isDesktop') ? 'fioc-mobile-error-wizard' : ''}`}
                        errorMessage={formatText('fiocSection-documentUploadErrorMessage')}
                        errorSubMessage={formatText('fiocSection-documentUploadErrorSubmessage')}
                        mainButton={goBackButton}
                        {...(!this.props.immScreen.get('isDesktop') && { onMainButtonClick: this.handleRedirectToCloseMobileFIOC })}
                    />
                );
            } else if (uploadFIOCDocumentsSuccess) {
                if (isAnyDocumentFailed) {
                    let subString = "", errorSubMessage;
                    let subMessage1 = formatText('fiocSection-documentUploadPartialErrorSubmessage1');
                    if (failedDocuments.length !== 0) {
                        failedDocuments.filter((document, index) => {
                            subString += document + ((index != (failedDocuments.length - 1)) ? ", " : ". ");
                        })
                        errorSubMessage = subMessage1.concat(subString) + formatText('fiocSection-documentUploadPartialErrorSubmessage2')
                    } else {
                        errorSubMessage = formatText('fiocSection-documentUploadErrorSubmessage');
                    }
                    wizard = (
                        <WizardError
                            customClassName={`fioc-upload-documents-view__error-wizard ${!immScreen.get('isDesktop') ? 'fioc-mobile-error-wizard' : ''}`}
                            errorMessage={formatText('fiocSection-documentUploadErrorMessage')}
                            errorSubMessage={errorSubMessage}
                            mainButton={goBackButton}
                            {...(!this.props.immScreen.get('isDesktop') && { onMainButtonClick: this.handleRedirectToCloseMobileFIOC })}
                        />
                    );

                } else {
                    wizard = (<WizardSuccess
                        customClassName={`fioc-upload-documents-view__success-wizard ${!immScreen.get('isDesktop') ? 'fioc-mobile-success-wizard' : ''}`}
                        successMessage={formatText('fiocSection-documentUploadSuccessMessage')}
                        successSubMessage={formatText('fiocSection-documentUploadSuccessSubmessage')}
                        mainButton={goBackButton}
                        {...(!this.props.immScreen.get('isDesktop') && { onMainButtonClick: this.handleRedirectToCloseMobileFIOC })}
                    >
                    </WizardSuccess>)
                }
            }
            return (
                <div className="col-xs-12 col-md-offset-1 col-md-10">
                    {wizard}
                </div>
            );
        } else {
            if (documentListError) {
                this.props.history.push(`/myprofile/edit`);
            } else {
                const disclaimerPersonalInfo = this.buildDisclaimerPersonalInfo();
                const validReceiptsModalBody = this.createValidReceiptsModalBody();
                const modalTitle = `fiocSection-${this.state.modalContent}Title`;
                const uploadSectionClassName = contactCenterClassName('fioc-upload-documents-view__upload-section-row', 'row')
                return (
                    <div className="fioc-upload-documents-view__content">
                        <div className="col-xs-12 col-md-8 fioc-upload-documents-view__upload-section">
                            <div className={`${uploadSectionClassName} ${!immScreen.get('isDesktop') && 'fioc-upload-documents-view-mobile'}`}>
                                <OKSectionBox>
                                    <h3 className="fioc-upload-documents-view__heading"><FormattedText value="fiocSection-documentUploadSectionTitle" /></h3>
                                    {uploadDocumentSectionSubTitle}
                                    {uploadInstructions}
                                    {uploadInformation}
                                    <FiocUploadBoxes
                                        documentList={documentList}
                                        modalOpen={this.modalOpen}
                                        maxSize={FILE_MAX_SIZE}
                                        validTypesFile={VALID_TYPES_FILE}
                                        handleAddChange={this.addChange}
                                        handleRemoveChange={this.removeChange}
                                        files={files}
                                        isAttachClicked={this.state.isAttachClicked}
                                        isDesktop={immScreen.get('isDesktop')}
                                    />
                                    <div className="fioc-upload-documents-view__partial-upload-message">
                                        <OKMessage type="important">
                                            <FormattedText value="fiocSection-optionalUpload" />
                                        </OKMessage>
                                    </div>
                                    {disclaimerPersonalInfo}
                                    <footer className="broker-internal-transfer-fund-select-funds-step__footer">
                                        {isDocumentUploadAllowed() &&
                                            <div className="row">
                                                <div className="col-xs-6">{
                                                    !immScreen.get('isDesktop') ?
                                                        <OKButton
                                                            onClick={this.handleRedirectToCloseMobileFIOC}
                                                            block={true}
                                                        > 
                                                            <FormattedText value="internalTransferFundSelectFundsStep-cancel" />
                                                        </OKButton>
                                                    :
                                                        <OKLink
                                                            extraClass="fioc-upload-documents-view__cancel-link"
                                                            to={ '/myprofile/edit'}
                                                        >
                                                            <FormattedText value="internalTransferFundSelectFundsStep-cancel" />
                                                        </OKLink>
                                                    }
                                                </div>
                                                <div className="col-xs-6 text-right">
                                                    <OKButton onClick={this.handleUpload} disabled={this.checkUploadDisable()}>
                                                        <FormattedText value="fiocSection-adjuntar" />
                                                    </OKButton>
                                                </div>
                                            </div>
                                        }
                                    </footer>
                                </OKSectionBox>
                            </div>
                        </div>
                        <div className={`col-xs-12 col-md-4 ${!immScreen.get('isDesktop') ? 'fioc-mobile-contact-info' : ''}`}>
                            <div className="row">
                                <div className="col-xs-6 col-md-12">
                                    <ContactInfoBox
                                        boxTitle={formatText("fiocSection-documentListTitle")}
                                        boxBody={documentListBox}
                                    />
                                </div>
                            </div>
                            <OKModal
                                content={validReceiptsModalBody}
                                isOpen={this.state.showAddressProofModal}
                                onCloseCallback={this.handleCloseModel}
                                title={modalTitle}
                                overlayClassName={!this.props.immScreen.get('isDesktop') ? 'fioc-upload-documents-modal__overlay' : ''}
                            />
                            <PreLeaveModalComponent
                                className={`${!immScreen.get('isDesktop') ? 'preleave-modal-mobile' : ''}`}
                                externalLink='/myprofile/global/'
                                confirmationMessage={formatText('wizard-redirectConfirmationMessage')}
                                confirmationTitle={formatText('wizard-redirectConfirmationTitle')}
                                acceptText={formatText('wizard-redirectConfirmationAcceptButton')}
                                cancelText={formatText('wizard-redirectConfirmationCancelButton')}
                                isReady={() => { window.console.log("isReady") }}
                                beforeLeaving={() => { window.console.log("beforeLeaving") }}
                                onConfirmLeave={() => { window.console.log("beConfirmLeave") }}
                            />
                        </div>
                    </div>
                );
            }

        }
    }

    createDocumentListBox() {
        const { documentList } = this.props;
        let doc03Count = 0;
        let ResultList = documentList.slice();
        documentList.map((document) => {
            if (document.get("codTipoDocumento") === FIOC_DOCUMENT_CODE_03) {
                ResultList = ResultList.push(document);
                return false;
            }
        });
        ResultList = ResultList.sort((object1, object2) => {
            return object1.get("codTipoDocumento") > object2.get("codTipoDocumento")
        });
        return (
            <div className="fioc-upload-documents-view__container">
                {
                    ResultList.map((item, ind) => {
                        const iconClassModifier = this.mapDocumentStatusToIcon[item.get("estadoDocumento")];
                        const iconClassName = "fioc-upload-documents-view__container__item__icon__tag-" + iconClassModifier + " icon-" + iconClassModifier;
                        let documentName = formatText("fiocSection-documentName" + item.get("codTipoDocumento"));
                        let documentStatus = formatText("fiocSection-status" + item.get("estadoDocumento"));
                        const statusFailedReason = item.get("motivoEstadoDocumento");
                        if ((item.get("estadoDocumento") === "RN" || item.get("estadoDocumento") === "RK") && statusFailedReason !== "") {
                            documentStatus = formatText("fiocSection-statusFailedReason" + statusFailedReason);
                        }
                        if (item.get("codTipoDocumento") === FIOC_DOCUMENT_CODE_03) {
                            doc03Count++;
                            if (doc03Count === 2) {
                                documentName = formatText("fiocSection-documentName" + item.get("codTipoDocumento") + "2");
                                documentStatus = formatText("fiocSection-status" + item.get("estadoDocumento"));
                            }
                        }
                        return (
                            <div className="fioc-upload-documents-view__container__item" key={ind}>
                                <div className="fioc-upload-documents-view__container__item__icon">
                                    <i className={iconClassName} />
                                </div>
                                <div className="fioc-upload-documents-view__container__item__content">
                                    <p className="fioc-upload-documents-view__container__item__content__name">{documentName}</p>
                                    <p className="fioc-upload-documents-view__container__item__content__message">{documentStatus}</p>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        );
    }

    createUploadInformation() {
        const validTypesFile = VALID_TYPES_FILE.filter(extension => {
            return extension !== "jpeg";
        })
        return (
            <div className="fioc-upload-documents-view__uploadinfo">
                {isDocumentUploadAllowed() &&
                    <p className="fioc-upload-documents-view__uploadinfo__para">{formatText("fiocSection-uploadinfoPara")}</p>
                }
                <p className="fioc-upload-documents-view__uploadinfo__size-extensions">
                    {formatText('fiocSection-uploadinfoSize')}
                    <span className="fioc-upload-documents-view__file-size">{FILE_MAX_SIZE / 1024}MB</span>
                    {formatText("fiocSection-uploadinfoExtensions")}
                    <span className="fioc-upload-documents-view__file-extensions">{validTypesFile.slice(0, validTypesFile.length - 1).join(", ")} o {validTypesFile[validTypesFile.length - 1]}</span>
                </p>
            </div>
        );
    }
    createUploadInstructions() {
        const instructions = [
            {
                instructionText: formatText("fiocSection-photoIntructitonsStep1"),
                iconClass: "icon-superficie-plana"
            }, {
                instructionText: formatText("fiocSection-photoIntructitonsStep2"),
                iconClass: "icon-nitidez"
            }, {
                instructionText: formatText("fiocSection-photoIntructitonsStep3"),
                iconClass: "icon-luz-natural"
            },
        ];
        return (
            <section className={`fioc-upload-documents-view__photo-intructitons ${!this.props.immScreen.get('isDesktop') ? 'fioc-upload-documents-view__photo-intructitons-mobile' : ''}`}>
                <OKBoxTitle
                    value={formatText('fiocSection-documentUploadInstructionsTitle')}
                    size={"medium"}
                />
                <div className="fioc-upload-documents-view__photo-intructitons__content clearfix">
                    {instructions.map((instruction, index) => (
                        <div key={index} className="fioc-upload-documents-view__photo-intructitons__steps">
                            <span className={"fioc-upload-documents-view__photo-intructitons__steps__icon " + instruction.iconClass}></span>
                            <p className="fioc-upload-documents-view__photo-intructitons__steps__desc">{instruction.instructionText}</p>
                        </div>
                    ))}
                </div>
            </section>
        );
    }
    createValidReceiptsModalBody() {
        const { modalContent } = this.state;
        const instructionItems = {// Amount of items (translations) to show in each modal
            domicilio: 2,
            ingresos: 10
        };
        let footerMsg;
        let instructions = [];
        for (let i = 1; i <= instructionItems[modalContent]; i++) {
            instructions.push(
                <li key={i}
                    className="fioc-upload-documents-view__receipts-instructions__list__item"
                >
                    <FormattedText value={`fiocSection-${modalContent}Instruction${i}`} />
                </li>
            );
        }

        if (modalContent === 'domicilio') {
            footerMsg = <FormattedText value="fiocSection-domicilioFooterMsg" />;
        }

        return (
            <div>
                <div className={`fioc-upload-documents-view__receipts-instructions`}>
                    <ul className="fioc-upload-documents-view__receipts-instructions__list">
                        {instructions}
                    </ul>
                    {footerMsg}
                </div>
            </div>
        );
    }
    handleCloseModel() {
        this.setState({
            showAddressProofModal: false
        })
    }
    handleContinueUploadClick() {
        this.setState({
            successUpload: false
        });
        this.props.getFiocDocumentList();
    }
    handleUpload() {
        const { files } = this.props;
        let isReadyUpload = false, doc01Count = 0, doc03Count = 0;
        files.map(file => {
            const documentCode = file["name"].split("-")[1];
            if (documentCode === FIOC_DOCUMENT_CODE_01) {
                doc01Count++;
            } else if (documentCode === FIOC_DOCUMENT_CODE_03) {
                doc03Count++;
            }
        });
        if ((doc01Count === 2 || doc01Count === 0) && (doc03Count === 3 || doc03Count === 0)) {
            isReadyUpload = true;
        }
        this.setState({
            successUpload: isReadyUpload,
            isAttachClicked: true
        })
        isReadyUpload && this.props.uploadFIOCDocuments(files);
    }
    modalOpen(name) {
        if (name === "ingresos") {
            this.setState({
                showAddressProofModal: true,
                modalContent: "ingresos"
            });
        } else {
            this.setState({
                showAddressProofModal: true,
                modalContent: "domicilio"
            });
        }
    }

    removeChange(fileState) {
        this.props.removeFile(fileState);
    }

    render() {
        const { isStatusFetching, uploadDocumentsPending, immScreen } = this.props;

        let bodyContent;
        if (isStatusFetching) {
            bodyContent = <LoadingSection />;
        } else {
            bodyContent = this.createBodyContent()
        }
        let titleKey = 'fiocSection-documentation';

        const mappingBreadcrumb = [
            {
                text: formatText('fiocSection-profileDataTitle'),
                url: '/myprofile/edit'
            },
            {
                text: formatText('fiocSection-title'),
                url: '/myprofile/edit/fioc'
            }
        ];

        return (
            <section className="fioc-upload-documents-view">
                 {!immScreen.get('isDesktop') ? 
                        <div className='mobile-fioc-header'>
                            <img
                                className="openbank-logo"
                                src={openbankLogo}
                            />
                        </div>
                        :
                        <OKCover size="medium" section="transfers">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle(titleKey)}
                            />
                        </OKCover>
                    }
                
                <section className="fioc-upload-documents-view__body">
                    {bodyContent}
                </section>
                {uploadDocumentsPending && !immScreen.get('isDesktop') && (
                <div className="fioc-upload-documents-view-spinner">
                    <LoadingSection />
                </div>
            )}
            </section>
        );
    }
}

FIOCUploadDocumentsView.propTypes = {
    documentList: PropTypes.object,
    getFiocDocumentList: PropTypes.func,
    files: PropTypes.object,
    history: PropTypes.object.isRequired,
    addFile: PropTypes.func,
    removeFile: PropTypes.func,
    isStatusFetching: PropTypes.bool,
    documentListError: PropTypes.object,
    uploadFIOCDocuments: PropTypes.func,
    uploadDocumentsPending: PropTypes.bool,
    uploadFIOCDocumentsSuccess: PropTypes.object,
    uploadFIOCDocumentsError: PropTypes.object,
    getFiocStatus: PropTypes.func,
    fiocFetched: PropTypes.bool,
}
FIOCUploadDocumentsView.defaultProps = {
    documentList: [],
    files: {}
};
module.exports.constructor = FIOCUploadDocumentsView;
module.exports.FIOCUploadDocumentsView = connect(
    state => ({
        documentList: state.fiocDocumentation.getIn(['documentList']),
        files: state.fiocDocumentation.getIn(['files']),
        immScreen: state.screen,
        isStatusFetching: state.fiocDocumentation.get('isStatusFetching'),
        documentListError: state.fiocDocumentation.get('documentListError'),
        uploadDocumentsPending: state.fiocDocumentation.get('uploadDocumentsPending'),
        uploadFIOCDocumentsSuccess: state.fiocDocumentation.get('uploadDocumentsSuccess'),
        uploadFIOCDocumentsError: state.fiocDocumentation.get('uploadDocumentsError'),
        fiocFetched: state.fiocDocumentation.get('fetched'),
    }), {
    getFiocDocumentList: fiocDocumentation.getFiocDocumentList,
    addFile: fiocDocumentation.addFile,
    removeFile: fiocDocumentation.removeFile,
    uploadFIOCDocuments: fiocDocumentation.uploadFIOCDocuments,
    getFiocStatus: fiocDocumentation.getFiocStatus,
    getFiocContent: interstitialsActions.getFiocContent,
}
)(withRouter(FIOCUploadDocumentsView));
